<script>
  import MenuHeading from "./../../shared/MenuHeading.svelte";
  import Layout from "../../Layout/Layout.svelte";
  import FStylesReusable from "./FStylesReusable.svelte";
</script>

<svelte:head>
  <title>Products Catalogue — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Products Catalogue"
    description="View the Products Catalogue (Read-Only)"
  />

  <FStylesReusable EDITABLE={false} />
</Layout>
